var _defs, _g, _path, _path2, _path3, _path4, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnLockedFiles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112.074,
    height: 91.855,
    viewBox: "0 0 112.074 91.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f{fill:none;}.a{stroke:#007da0;stroke-width:7px;}.b{fill:#21c6f3;}.c{fill:#0fb4d1;}.d{fill:#12dcc8;}.e{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.155 14.374)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-0.453 0.481)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 84,
    height: 77,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 3.5,
    y: 3.5,
    width: 77,
    height: 70,
    rx: 6.5
  })), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 78,
    transform: "translate(2.047 17.981)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 16,
    transform: "translate(52.047 2.981)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 16,
    transform: "translate(67.047 2.981)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M391.771,271.163c-3.177-.906-4.578-2.24-4.784-5.344-.207,3.1-1.607,4.438-4.784,5.344,3.176.906,4.577,2.24,4.784,5.344C387.193,273.4,388.594,272.068,391.771,271.163Z",
    transform: "translate(-359.516 -227.879)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M391.771,271.163c-3.177-.906-4.578-2.24-4.784-5.344-.207,3.1-1.607,4.438-4.784,5.344,3.176.906,4.577,2.24,4.784,5.344C387.193,273.4,388.594,272.068,391.771,271.163Z",
    transform: "translate(-381.872 -247.447)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M381.3,214.04c-3.177-.905-4.577-2.24-4.784-5.344-.207,3.1-1.607,4.438-4.783,5.344,3.176.905,4.576,2.241,4.783,5.344C376.725,216.28,378.125,214.945,381.3,214.04Z",
    transform: "translate(-371.735 -139.545)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M410.493,235.515c-2.194-.625-3.162-1.548-3.3-3.692-.143,2.144-1.111,3.066-3.3,3.692,2.194.625,3.162,1.547,3.3,3.691C407.332,237.062,408.3,236.14,410.493,235.515Z",
    transform: "translate(-323.159 -159.008)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.465 33.994)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M328.692,212.916c-2.194-.626-3.161-1.548-3.3-3.691-.143,2.143-1.11,3.066-3.3,3.691,2.194.625,3.161,1.547,3.3,3.691C325.531,214.463,326.5,213.542,328.692,212.916Z",
    transform: "translate(-322.084 -209.225)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.221)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M328.692,212.916c-2.194-.626-3.161-1.548-3.3-3.691-.143,2.143-1.11,3.066-3.3,3.691,2.194.625,3.161,1.547,3.3,3.691C325.531,214.463,326.5,213.542,328.692,212.916Z",
    transform: "translate(-322.084 -209.225)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-980.46 -521.892)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1036.439,648.754h3.132q4.019,0,8.039,0a2.513,2.513,0,0,1,2.578,2,3.327,3.327,0,0,1,.061.686q0,5.494,0,10.988,0,3.9.007,7.809a2.519,2.519,0,0,1-2.558,2.576c-1.7,0-3.409-.007-5.114-.008q-2.891,0-5.781,0h-3.5c-2.649,0-5.3-.026-7.947.01a2.564,2.564,0,0,1-2.612-2.612c.027-3.371,0-6.742,0-10.112q0-4.469,0-8.937a2.464,2.464,0,0,1,2.293-2.369c1.911-.027,3.823-.015,5.735-.018l5.413-.008Zm-1.188,14.3h-.007c0,.361,0,.722,0,1.083a1.3,1.3,0,0,0,.291.853,1.226,1.226,0,0,0,1.353.377,1.194,1.194,0,0,0,.835-1.1c.016-.76.016-1.52.01-2.28a.334.334,0,0,1,.2-.34,2.833,2.833,0,0,0,1.427-1.886,2.943,2.943,0,0,0-5.083-2.616,2.93,2.93,0,0,0,.778,4.493.326.326,0,0,1,.2.337C1035.242,662.331,1035.252,662.692,1035.252,663.053Z",
    transform: "translate(0 -73.197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1049.346,574.461h-3.406c-.013-.027-.025-.04-.025-.053a19.268,19.268,0,0,1,.219-4.22,9.911,9.911,0,0,1,4.581-6.493,9.707,9.707,0,0,1,8.071-1.154,9.93,9.93,0,0,1,6.982,6.741,9.242,9.242,0,0,1,.465,3.058c-.005.7,0,1.4,0,2.114h-3.439c0-.075-.011-.156-.011-.237,0-.7.029-1.4,0-2.1a6.529,6.529,0,0,0-3.044-5.419,6.7,6.7,0,0,0-9.334,2.022,6.838,6.838,0,0,0-1.055,3.712C1049.342,573.1,1049.346,573.771,1049.346,574.461Z",
    transform: "translate(-19.573)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnLockedFiles);
export default __webpack_public_path__ + "static/media/icn-locked-files.6addc1e32818dc0b68d48364e41dea95.svg";
export { ForwardRef as ReactComponent };